import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class DocumentTypesService {
  constructor(private http: HttpClient) {}

  public fetchDocumentTypes(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/documentType/list`
    return this.http.post(url, params)
  }
  public fetchDocumentType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/documentType/${id}`
    return this.http.get(url, {})
  }

  public deleteDocumentType(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/documentType/${id}`
    return this.http.delete(url)
  }

  public createDocumentType(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/documentType`
    return this.http.post(url, params)
  }

  public updateDocumentType(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/documentType/${id}`
    return this.http.put(url, params)
  }
}
